module.exports = __webpack_public_path__ + "img/apoio-mayds.95eee924.png";